<template>
  <div class="subaccount-container">
    <!-- 搜索表单 -->
    <div class="content-card">
      <div class="card-header">
         <a-icon type="user" class="header-icon" />
        <div class="header-title">{{ translate('subaccount.title') }}</div>
      </div>
      <a-form
        :model="formData"
        @submit.prevent="onSubmit"
        layout="inline"
        :style="{ marginBottom: '20px' }"
      >
        <a-form-item name="uname">
          <a-input
            v-model="formData.uname"
            :placeholder="translate('subaccount.search.placeholder')"
            style="min-width: 220px"
            allow-clear
            @pressEnter="onSubmit"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="onSubmit" :disabled="actionLock">{{ translate('subaccount.search.button') }}</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="showAllocateModal" :disabled="actionLock">{{ translate('subaccount.add.button') }}</a-button>
        </a-form-item>
      </a-form>
      
      <!-- 流量统计 -->
      <div class="flow-stats-container">
        <div class="flow-stat-item">
          <span class="flow-stat-label">{{ translate('subaccount.flow.master.available') }}</span>
          <span class="flow-stat-value">{{ Number(masterInfo.flow) - Number(masterInfo.consumeFlow) }}GB</span>
        </div>
        <div class="flow-stat-item">
          <span class="flow-stat-label">{{ translate('subaccount.flow.son.total') }}</span>
          <span class="flow-stat-value">{{ sonFlow.toFixed(2) }}GB</span>
        </div>
        <div class="flow-stat-item">
          <span class="flow-stat-label">{{ translate('subaccount.flow.son.available') }}</span>
          <span class="flow-stat-value">{{ sonFlowCanUse.toFixed(2) }}GB</span>
        </div>
      </div>
    </div>
    
    <!-- 子账号列表 -->
    <div class="content-card">
      <a-table
        :columns="columns"
        :data-source="datalist"
        rowKey="nodeId"
        :loading="dataLoading"
        :scroll="{ x: 1300 }"
        size="middle"
        class="custom-table"
      >
        <!-- 操作列 -->
        <template slot="action" slot-scope="text, record">
          <a-space size="small">
            <a-button type="primary" size="small" @click="handleClickadd(record)" :disabled="actionLock">{{ translate('subaccount.action.add.flow') }}</a-button>
            <a-button size="small" @click="handleClickdeduct(record)" :disabled="actionLock">{{ translate('subaccount.action.deduct.flow') }}</a-button>
            <a-button danger size="small" @click="changeword(record)" :disabled="actionLock">{{ translate('subaccount.action.delete') }}</a-button>
            <a-button size="small" @click="edit(record)" :disabled="actionLock">{{ translate('subaccount.action.edit.remark') }}</a-button>
          </a-space>
        </template>
      </a-table>
    </div>
    

    
    <!-- 添加子账号模态框 -->
    <a-modal
      :visible.sync="visiblefp"
      :title="translate('subaccount.modal.add.title')"
      @ok="onflewform"
      @cancel="onCloseform"
      :confirmLoading="confirmLoading"
    >
      <a-form :model="cutflewform" layout="vertical">
        <a-form-item :label="translate('subaccount.modal.add.flow.label')">
          <a-input v-model="cutflewform.flow" :placeholder="translate('subaccount.modal.add.flow.placeholder')" />
        </a-form-item>
        <a-form-item :label="translate('subaccount.modal.add.username.label')">
          <a-input v-model="cutflewform.sonname" :placeholder="translate('subaccount.modal.add.username.placeholder')" />
        </a-form-item>
        <a-form-item :label="translate('subaccount.modal.add.password.label')">
          <a-input v-model="cutflewform.password" :placeholder="translate('subaccount.modal.add.password.placeholder')" />
        </a-form-item>
      </a-form>
    </a-modal>
    
    <!-- 添加流量模态框 -->
    <a-modal
      :visible.sync="visiblenewfp"
      :title="translate('subaccount.modal.add.flow.title')"
      @ok="addflew"
      @cancel="onCloseflew"
      :confirmLoading="confirmLoading"
    >
      <a-form :model="addflewform" layout="vertical">
        <a-form-item :label="translate('subaccount.modal.add.flow.title')">
          <a-input v-model="addflewform.flow" :placeholder="translate('subaccount.modal.add.flow.input.placeholder')" />
        </a-form-item>
      </a-form>
    </a-modal>
    
    <!-- 扣除流量模态框 -->
    <a-modal
      :visible.sync="visiblenewfd"
      :title="translate('subaccount.modal.deduct.flow.title')"
      @ok="dudflew"
      @cancel="onCloseflewd"
      :confirmLoading="confirmLoading"
    >
      <a-form :model="dudflewform" layout="vertical">
        <a-form-item :label="translate('subaccount.modal.deduct.flow.title')">
          <a-input v-model="dudflewform.flow" :placeholder="translate('subaccount.modal.deduct.flow.placeholder')" />
        </a-form-item>
      </a-form>
    </a-modal>
    
    <!-- 编辑备注模态框 -->
    <a-modal
      :visible.sync="visibledit"
      :title="translate('subaccount.modal.edit.remark.title')"
      @ok="updateEdit"
      @cancel="onCloseEdit"
      :okButtonProps="{ props: { disabled: actionLock } }"
    >
      <a-form :model="editform" layout="vertical">
        <a-form-item :label="translate('subaccount.modal.edit.remark.label')">
          <a-input v-model="editform.remark" :placeholder="translate('subaccount.modal.edit.remark.placeholder')" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'SubAccount',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'en';
    },
    columns() {
      return [
        {
          title: this.translate('subaccount.column.username'),
          dataIndex: 'username',
          key: 'username',
          width: 120,
        },
        {
          title: this.translate('subaccount.column.flow'),
          dataIndex: 'countFlow',
          key: 'countFlow',
          width: 100,
        },
        {
          title: this.translate('subaccount.column.used.flow'),
          dataIndex: 'consumeFlow',
          key: 'consumeFlow',
          width: 100,
        },
        {
          title: this.translate('subaccount.column.host'),
          dataIndex: 'ip',
          key: 'ip',
          width: 150,
        },
        {
          title: this.translate('subaccount.column.port'),
          dataIndex: 'port',
          key: 'port',
          width: 80,
        },
        {
          title: this.translate('subaccount.column.password'),
          dataIndex: 'password',
          key: 'password',
          width: 150,
        },
        {
          title: this.translate('subaccount.column.create.time'),
          dataIndex: 'createTime',
          key: 'createTime',
          width: 180,
        },
        {
          title: this.translate('subaccount.column.remark'),
          dataIndex: 'remark',
          key: 'remark',
          width: 100,
        },
        {
          title: this.translate('subaccount.column.action'),
          key: 'action',
          width: 400,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
  },
  data() {
    return {
      actionLock: false, // 按钮锁
      timer: '', // 定时器名称
      uid: localStorage.getItem("userId"),
      dataTypeList: [],
      rules: {
        sonname: [{ required: true, message: '用户名必填', trigger: 'blur' }],
        password: [{ required: true, message: '密码必填', trigger: 'blur' }],
      },
      formData: {
        uname: '',
        username: '',
        pageNum: 1,
        pageSize: 10,
      },

      cutflewform: {
        flow: '',
        password: '',
        sonname: '',
        dataType: '',
      },
      addflewform: {
        flow: '',
      },
      dudflewform: {
        flow: '',
      },
      editform: {
        remark: '',
      },
      passform: {
        password: ''
      },
      datalist: [],
      visiblefp: false,
      visiblenewfp: false,
      visiblenewfd: false,
      visibledit: false,
      dataLoading: false,
      uname: '',
      realyAccount: '',
      realyAccounts: '',
      sonAccountNames: '',
      nodeId: '',
      upids: '',
      cid: '',
      uids: '',
      value: 'first',
      // 当前编辑的行数据
      currentEditRow: null,
      masterInfo: {
        flow: 0,
        consumeFlow: 0
      },
      sonFlow: 0, // 子账号总流量
      sonFlowCanUse: 0, // 子账号剩余流量
      confirmLoading: false,
    };
  },
  mounted() {
    this.dataLoading = true;
    this.getlist();
    // this.getTypelist();
    this.start();
  },
  methods: {
    // 按钮锁处理，防止连点
    handleLock() {
      if (this.actionLock) return true;
      this.actionLock = true;
      setTimeout(() => {
        this.actionLock = false;
      }, 3000);
      return false;
    },
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'subaccount.title': lang === 'zh' ? '子账号管理' : 'Sub Account Management',
        'subaccount.search.placeholder': lang === 'zh' ? '搜索用户名' : 'Search Username',
        'subaccount.search.button': lang === 'zh' ? '搜索' : 'Search',
        'subaccount.add.button': lang === 'zh' ? '添加子账号' : 'Add Sub Account',
        'subaccount.flow.master.available': lang === 'zh' ? '主账号可分配流量' : 'Master Account Available Flow',
        'subaccount.flow.son.total': lang === 'zh' ? '子账号总流量' : 'Sub Account Total Flow',
        'subaccount.flow.son.available': lang === 'zh' ? '子账号剩余总流量' : 'Sub Account Remaining Flow',
        'subaccount.column.username': lang === 'zh' ? '用户名' : 'Username',
        'subaccount.column.flow': lang === 'zh' ? '流量' : 'Flow',
        'subaccount.column.used.flow': lang === 'zh' ? '已用流量' : 'Used Flow',
        'subaccount.column.host': lang === 'zh' ? '主机' : 'Host',
        'subaccount.column.port': lang === 'zh' ? '端口' : 'Port',
        'subaccount.column.password': lang === 'zh' ? '密码' : 'Password',
        'subaccount.column.create.time': lang === 'zh' ? '创建时间' : 'Create Time',
        'subaccount.column.remark': lang === 'zh' ? '备注' : 'Remark',
        'subaccount.column.action': lang === 'zh' ? '操作' : 'Action',
        'subaccount.action.add.flow': lang === 'zh' ? '添加流量' : 'Add Flow',
        'subaccount.action.deduct.flow': lang === 'zh' ? '扣除流量' : 'Deduct Flow',
        'subaccount.action.delete': lang === 'zh' ? '删除' : 'Delete',
        'subaccount.action.edit.remark': lang === 'zh' ? '编辑备注' : 'Edit Remark',
        'subaccount.modal.add.title': lang === 'zh' ? '添加子账号' : 'Add Sub Account',
        'subaccount.modal.add.flow.label': lang === 'zh' ? '流量' : 'Flow',
        'subaccount.modal.add.username.label': lang === 'zh' ? '用户名' : 'Username',
        'subaccount.modal.add.password.label': lang === 'zh' ? '密码' : 'Password',
        'subaccount.modal.add.flow.placeholder': lang === 'zh' ? '请输入流量' : 'Please enter flow',
        'subaccount.modal.add.username.placeholder': lang === 'zh' ? '请输入用户名' : 'Please enter username',
        'subaccount.modal.add.password.placeholder': lang === 'zh' ? '请输入密码' : 'Please enter password',
        'subaccount.modal.add.flow.title': lang === 'zh' ? '添加流量' : 'Add Flow',
        'subaccount.modal.add.flow.input.placeholder': lang === 'zh' ? '请输入添加流量' : 'Please enter add flow',
        'subaccount.modal.deduct.flow.title': lang === 'zh' ? '扣除流量' : 'Deduct Flow',
        'subaccount.modal.deduct.flow.placeholder': lang === 'zh' ? '请输入扣除流量' : 'Please enter deduct flow',
        'subaccount.modal.edit.remark.title': lang === 'zh' ? '编辑备注' : 'Edit Remark',
        'subaccount.modal.edit.remark.label': lang === 'zh' ? '备注' : 'Remark',
        'subaccount.modal.edit.remark.placeholder': lang === 'zh' ? '请输入备注' : 'Please enter remark',
        'subaccount.message.warning.incomplete': lang === 'zh' ? '请填写完整信息' : 'Please fill in complete information',
        'subaccount.message.success.add': lang === 'zh' ? '添加子账号成功' : 'Add sub account success',
        'subaccount.message.success.edit': lang === 'zh' ? '修改成功' : 'Edit success',
        'subaccount.message.success.action': lang === 'zh' ? '操作成功' : 'Action success',
        'subaccount.message.warning.invalid.flow': lang === 'zh' ? '请输入有效的流量值' : 'Please enter valid flow value',
        'subaccount.message.warning.failed.get': lang === 'zh' ? '获取子账号信息失败' : 'Failed to get sub account information',
        'subaccount.message.error.add': lang === 'zh' ? '添加子账号失败' : 'Failed to add sub account',
        'subaccount.message.error.edit': lang === 'zh' ? '编辑备注失败' : 'Failed to edit remark',
        'subaccount.message.error.deduct': lang === 'zh' ? '扣除流量失败' : 'Failed to deduct flow',
        'subaccount.message.error.add.flow': lang === 'zh' ? '添加流量失败' : 'Failed to add flow',
        'subaccount.message.error.delete': lang === 'zh' ? '删除子账号失败' : 'Failed to delete sub account',
        'subaccount.confirm.delete.title': lang === 'zh' ? '删除确认' : 'Delete Confirmation',
        'subaccount.confirm.delete.content': lang === 'zh' ? '确定要删除子账号' : 'Are you sure to delete sub account',
        'subaccount.confirm.delete.cancel': lang === 'zh' ? '取消' : 'Cancel',
        'subaccount.message.error.get.list': lang === 'zh' ? '获取子账号列表失败' : 'Failed to get sub account list',
      };
      return translations[key] || key;
    },
    // 登录状态测试
    getLoginStatus() {
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear();
          this.$message.warning('请重新登录！');
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    start() {
      this.timer = setInterval(this.getLoginStatus, 10000); // 第一个参数为方法名的时候不要加括号;
    },
    // 获取列表数据
    getlist() {
      this.dataLoading = true;
      this.sonFlow = 0;
      this.sonFlowCanUse = 0;
      this.$request.post('/ums/Pro/selectSonAccountList?uid='+ this.uid +'&uname='+ this.formData.uname).then((res) => {
        if (res.data.code === 200) {
          this.datalist = res.data.data;
          if(this.datalist.length > 0){
            this.datalist.forEach((item) => {
              if(item.type == "master"){
                this.masterInfo = item;
              }else{
                this.sonFlowCanUse += (Number(item.countFlow) - Number(item.consumeFlow));
                this.sonFlow += Number(item.countFlow);
              }
            });
          }
        } else {
          this.$message.error(res.data.msg || '获取子账号列表失败');
        }
      })
      .catch((e) => {
        console.error('获取子账号列表失败:', e);
        this.$message.error(this.translate('subaccount.message.error.get.list'));
      })
      .finally(() => {
        this.dataLoading = false;
      });
    },    // 获取数据类型下拉列表
    getTypelist() {
      this.$request.get('/openapi/selectDtdataType').then((res) => {
        this.dataTypeList = res.data
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.dataLoading = false;
      });
    },
    // 显示分配流量模态框（添加子账号）
    showAllocateModal() {
      if (this.handleLock()) return;
      this.visiblefp = true;
      this.resetCutflewform();
    },
    // 分配账户确认（添加子账号）
    onflewform() {
      if (!this.cutflewform.sonname || !this.cutflewform.password || !this.cutflewform.flow) {
        this.$message.warning(this.translate('subaccount.message.warning.incomplete'));
        return;
      }
      this.confirmLoading = true;
      // 构建请求参数
      const params = {
        ...this.cutflewform,
        uid: localStorage.getItem('userId') || '1',
        uname: this.cutflewform.sonname,
        realyAccount: this.cutflewform.sonname
      };
      this.$request.post('/ums/addSonAcount', params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(this.translate('subaccount.message.success.add'))
          this.getlist()
          this.visiblefp = false;
          this.resetCutflewform();
        } else {
          this.$message.warning(res.data.msg || '添加失败')
        }
      })
      .catch((e) => {
        console.error('添加子账号失败:', e);
        this.$message.error(this.translate('subaccount.message.error.add'));
      })
      .finally(() => {
        this.confirmLoading = false;
      });
    },
    // 重置分配流量表单
    resetCutflewform() {
      this.cutflewform = { flow: '', password: '', sonname: '', dataType: '' };
    },
    // 添加账户关闭
    onCloseform() {
      this.visiblefp = false;
      this.resetCutflewform();
    },
    // 编辑备注关闭
    onCloseEdit() {
      this.editform.remark = '';
      this.visibledit = false;
    },
    // 添加流量关闭
    onCloseflew() {
      this.addflewform.flow = '';
      this.visiblenewfp = false;
    },
    // 扣除流量关闭
    onCloseflewd() {
      this.dudflewform.flow = '';
      this.visiblenewfd = false;
    },
    // 编辑备注确认
    updateEdit() {
      if (this.handleLock()) return;
      // 检查nodeId和当前编辑行
      if (!this.nodeId || !this.currentEditRow) {
        this.$message.warning(this.translate('subaccount.message.warning.failed.get'));
        this.visibledit = false;
        return;
      }
      
      // 构建请求参数
      const params = {
        ...this.editform,
        nodeId: this.nodeId,
        // 添加额外标识信息，提高API调用成功率
        username: this.currentEditRow.username,
        realyAccount: this.currentEditRow.realyAccount
      };
      
      this.$request.post('/ums/updateRemark', params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(this.translate('subaccount.message.success.edit'))
          this.visibledit = false;
          this.getlist();
          this.resetEditForm();
        } else {
          this.$message.warning(res.data.msg || '修改失败')
        }
      })
      .catch((e) => {
        console.error('编辑备注失败:', e);
        this.$message.error(this.translate('subaccount.message.error.edit'));
      })
    },
    // 重置编辑表单
    resetEditForm() {
      this.editform.remark = '';
      this.nodeId = '';
      this.currentEditRow = null;
    },
    // 扣除流量确认
    dudflew() {
      if (!this.dudflewform.flow || Number(this.dudflewform.flow) <= 0) {
        this.$message.warning(this.translate('subaccount.message.warning.invalid.flow'));
        return;
      }
      this.confirmLoading = true;
      this.$request.post('/ums/reduceSonFlow', {
        ...this.dudflewform,
        uid: Number(this.uid || '1'),
        upid: this.upids,
        cid: this.cids,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(this.translate('subaccount.message.success.action'))
          this.visiblenewfd = false;
          this.getlist();
          this.dudflewform.flow = '';
        } else {
          this.$message.warning(res.data.msg || '操作失败')
        }
      })
      .catch((e) => {
        console.error('扣除流量失败:', e);
        this.$message.error(this.translate('subaccount.message.error.deduct'));
      })
      .finally(() => {
        this.confirmLoading = false;
      });
    },
    // 添加流量确认
    addflew() {
      if (!this.addflewform.flow || Number(this.addflewform.flow) <= 0) {
        this.$message.warning(this.translate('subaccount.message.warning.invalid.flow'));
        return;
      }
      this.confirmLoading = true;
      this.$request.post('/ums/addcumuflowClient', {
        ...this.addflewform,
        uid: Number(this.uid || '1'),
        upid: this.upids,
        cid: this.cids,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(this.translate('subaccount.message.success.action'))
          this.visiblenewfp = false;
          this.getlist();
          this.addflewform.flow = '';
        } else {
          this.$message.warning(res.data.msg || '操作失败')
        }
      })
      .catch((e) => {
        console.error('添加流量失败:', e);
        this.$message.error(this.translate('subaccount.message.error.add.flow'));
      })
      .finally(() => {
        this.confirmLoading = false;
      });
    },
    // 提交搜索
    onSubmit() {
      if (this.handleLock()) return;
      this.masterInfo = {
        flow: 0,
        consumeFlow: 0
      };
      this.sonFlow = 0; // 子账号总流量
      this.sonFlowCanUse = 0; // 子账号剩余流量
      this.getlist();
    },
    // 点击分配流量按钮
    rehandleClickOp(row) {
      if (this.handleLock()) return;
      this.uname = row.username;
      this.visiblefp = true;
      this.realyAccount = row.realyAccount;
    },
    // 点击添加流量按钮
    handleClickadd(row) {
      if (this.handleLock()) return;
      this.uids = row.uid;
      this.upids = row.upid;
      this.cids = row.cid;
      this.visiblenewfp = true;
    },
    // 点击扣除流量按钮
    handleClickdeduct(row) {
      if (this.handleLock()) return;
      this.uids = row.uid;
      this.upids = row.upid;
      this.cids = row.cid;
      this.visiblenewfd = true;
    },
    // 点击编辑备注按钮
    edit(row) {
      if (this.handleLock()) return;
      // 检查row对象
      console.log(row);
      if (!row) {
        this.$message.warning(this.translate('subaccount.message.warning.failed.get'));
        return;
      }
      // 显示当前备注内容
      this.editform.remark = row.remark || '';
      // 存储节点ID或用户名（作为备选）
      this.nodeId = row.nodeId || row.id || row.username;
      this.currentEditRow = row;
      this.visibledit = true;
    },
    // 点击删除按钮
    changeword(row) {
      if (this.handleLock()) return;
      // 检查row对象
      if (!row) {
        this.$message.warning('获取子账号信息失败');
        return;
      }
      // 使用nodeId或其他唯一标识
      const nodeId = row.nodeId || row.id || row.username;
      if (!nodeId) {
        this.$message.warning('无法获取子账号唯一标识');
        return;
      }
      // 使用Ant Design Vue 1.x的confirm正确用法
      this.$confirm({
        title: this.translate('subaccount.confirm.delete.title'),
        content: this.translate('subaccount.confirm.delete.content') + ' ' + row.username + '?',
        okType: 'danger',
        cancelText: this.translate('subaccount.confirm.delete.cancel'),
        onOk: () => {
          return this.$request.delete('/ums/delectSonAccount?id=' + row.nodeId + '&sonAccountName=' + row.username + '&realyAccount=' + row.realyAccount).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(this.translate('subaccount.message.success.action'))
              this.getlist();
            } else {
              this.$message.warning(res.data.msg || '删除失败')
            }
          })
          .catch((e) => {
            console.error('删除子账号失败:', e);
            this.$message.error(this.translate('subaccount.message.error.delete'));
          })
        },
        onCancel: () => {
          // 取消删除，不做任何操作
        }
      });
    },
  },
  // 清空定时器
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style scoped lang="less">
.subaccount-container {
  padding: 24px;
  background: #ffffff;
  min-height: calc(100vh - 98px);
}

/* 卡片样式 */
.content-card {
  border-radius: 16px;
  margin-bottom: 32px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: white;
  border: 1px solid #f5f5f5;
  padding: 16px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-color: #e6f7ff;
  }

  :deep(.ant-card-body) {
    padding: 36px;
  }
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f0f0f0;
  transition: all 0.3s ease;

  .header-icon {
    font-size: 28px;
    color: #1890ff;
    margin-right: 20px;
    transition: all 0.3s ease;
  }

  .header-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.5px;
  }
}

/* 流量统计容器 */
.flow-stats-container {
  display: flex;
  gap: 48px;
  flex-wrap: wrap;
  padding: 28px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%);
  border-radius: 12px;
  border: 1px solid #91d5ff;
  margin-top: 24px;
}

.flow-stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 200px;
}

.flow-stat-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  font-weight: 500;
}

.flow-stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #1890ff;
}

/* 表格样式 */
.custom-table {
  :deep(.ant-table-thead > tr > th) {
    background: #fafafa;
    font-weight: 600;
    border-bottom: 2px solid #f0f0f0;
    padding: 16px 12px;
  }

  :deep(.ant-table-tbody > tr:hover > td) {
    background: #e6f7ff;
  }

  :deep(.ant-table-row) {
    transition: all 0.3s ease;
  }

  :deep(.ant-table-tbody > tr > td) {
    padding: 16px 12px;
  }
}

/* 表单样式 */
:deep(.ant-form-inline .ant-form-item) {
  margin-bottom: 0;
  margin-right: 16px;
}

/* 按钮样式 */
:deep(.ant-btn) {
  transition: all 0.3s ease;
  border-radius: 6px;
  font-weight: 500;
}

:deep(.ant-btn-primary) {
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  border: none;
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.3);
  
  &:hover {
    background: linear-gradient(135deg, #40a9ff 0%, #69c0ff 100%);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
    transform: translateY(-1px);
  }
}

:deep(.ant-btn-danger) {
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  border: none;
  box-shadow: 0 2px 6px rgba(255, 77, 79, 0.3);
  
  &:hover {
    background: linear-gradient(135deg, #ff7875 0%, #ffa39e 100%);
    box-shadow: 0 4px 12px rgba(255, 77, 79, 0.4);
    transform: translateY(-1px);
  }
}

/* 间距 */
:deep(.ant-space-item) {
  margin: 0;
}

/* 模态框样式 */
:deep(.ant-modal-header) {
  border-radius: 8px 8px 0 0;
  background: linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%);
}

:deep(.ant-modal-title) {
  font-weight: 600;
  color: #1890ff;
}

:deep(.ant-modal-footer) {
  border-top: 1px solid #f0f0f0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .subaccount-container {
    padding: 16px;
  }
  
  .content-card {
    :deep(.ant-card-body) {
      padding: 16px;
    }
  }
  
  .flow-stats-container {
    flex-direction: column;
    gap: 16px;
  }
  
  :deep(.ant-form-inline) {
    flex-direction: column;
    align-items: flex-start;
  }
  
  :deep(.ant-form-inline .ant-form-item) {
    margin-right: 0;
    margin-bottom: 16px;
  }
}
</style>